import React from 'react';
import gql from 'graphql-tag';
import {FieldConfigurationFragment} from '../../../scenes/app/formConfiguration/fragments';
import SimpleFieldForm, {SimpleFieldFormProps} from './SimpleFieldForm';

export default function TextForm({
  sectionId, defaultLanguage, configuration, onCreateUpdate,
}: SimpleFieldFormProps) {
  return (
    <SimpleFieldForm sectionId={sectionId} configuration={configuration} defaultLanguage={defaultLanguage}
      onCreateUpdate={onCreateUpdate} createMutation={createMutation} updateMutation={updateMutation}/>
  );
}

const createMutation = gql`
  mutation CreateMutation($type: FormType!, $data: TextInput!) {
    field: createTextField(type: $type, data: $data) {
      ...CompleteFieldConfiguration
    }
  }
  ${FieldConfigurationFragment}
`;

const updateMutation = gql`
  mutation UpdateMutation($id: ID!, $type: FormType!, $data: TextInput!) {
    field: updateTextField(id: $id, type: $type, data: $data) {
      ...CompleteFieldConfiguration
    }
  }
  ${FieldConfigurationFragment}
`;
